import React, { useEffect, useState } from "react";
import { Alert, Checkbox } from "antd";
import { UpdateWelcome } from "../api/updateWelcome";

interface NewVersionAlertProps {
   showmessage: boolean;
}

const NewVersionAlert: React.FC<NewVersionAlertProps> = ({ showmessage }) => {
  const [visible, setVisible] = useState(showmessage);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // const hidden = localStorage.getItem(LOCAL_WELCOME_KEY);
    // console.log("hidden = " + hidden);
    // if (hidden !== "true") {
    //   setVisible(true);
    // }
    console.log("showmessage = " + showmessage);
    setVisible(showmessage);
  }, [showmessage]);

  const handleCheckboxChange = (e: any) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
  };

  const handleClose = () => {
    setVisible(false);
    UpdateWelcome(checked ? 1 : 0)
    .then((response) => {
        if (response.success)
        {
            console.log("Update Welcome Status Success");
        }
    })
    .catch((error) => {
        console.error("An error occurred:", error.message);
        return
    });   
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div style={{ width: 600 }}>
        <Alert
        //   message="🎉 Welcome!!!"
          description={
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <iframe
              src={"html/welcome.html?_="+Date.now()}
              style={{ width: '100%', height: '400px', border: 'none', overflow: 'hidden' }}
            ></iframe>
              {/* <span>Welcome to the new version—enjoy the upgrade!</span> */}
              <Checkbox checked={checked} onChange={handleCheckboxChange}>
                Don't show this again
              </Checkbox>
            </div>
          }
          type="success"
          closable
          onClose={handleClose}
        />
      </div>
    </div>
  );
};

export default NewVersionAlert;